import React from "react";
import style from "./style.scss";
import classNames from "classnames";

export const BoxFooter = ({ children, height }) => {
    return (
        <div className={classNames(style.footer, { [style.heightFixed]: height === "fixed" })}>
            <div className={style.wrapper}>{children}</div>
        </div>
    );
};
